const WS_PASSWORD_RULE_ACTIONS = {
  SUCCESS: 'success',
  ERROR: 'error',
  PASS: 'pass',
  SET_INITIAL_DATA: 'set-data',
  CHECK_LENGTH: 'check-length',
  CHECK_UPPER_CASE: 'check-upper-case',
  CHECK_LOWER_CASE: 'check-lower-case',
  CHECK_NUMBER: 'check-number',
  CHECK_SPECIAL_CHARACTER: 'check-special-character',
  CHECK_CHARACTER_TYPE: 'check-character-type',
  CHECK_ORG_ID: 'check-org-id',
  CHECK_DAILY_CHANGE_COUNT: 'check-daily-change-count',
  CHECK_PASSWORD_HISTORY: 'check-password-history'
};

const webServicePasswordRuleReducer = (state, action) => {

  //console.log("webServicePasswordRuleReducer dispatch triggered", state, action, state.characterCheck);

  /**
  {
    lengthCheck: false,
    // 3 of 4 checkers 
    characterCheck: {
      uppercaseCheck: false,
      lowercaseCheck: false,
      numberCheck: false,
      //: ! @ # $ % & * ( ) _ = + - [ ] ?
      specialCharCheck: false
    },
    orgIdCheck: true,
    historyCheck: true,
    countLimitCheck: true
  }
  */

  let charCheckObj = state.characterCheck;

  switch (action.type) {
    case WS_PASSWORD_RULE_ACTIONS.SET_INITIAL_DATA: {
      return {
        ...state,
        lengthCheck: false,
        // 3 of 4 checkers 
        characterCheck: {
          uppercaseCheck: false,
          lowercaseCheck: false,
          numberCheck: false,
          //: ! @ # $ % & * ( ) _ = + - [ ] ?
          specialCharCheck: false
        },
        orgIdCheck: false,
        historyCheck: false,
        countLimitCheck: true
      };
    }
    case WS_PASSWORD_RULE_ACTIONS.CHECK_LENGTH: {

      return {
        ...state,
        lengthCheck: action.value
      }
    }
    case WS_PASSWORD_RULE_ACTIONS.CHECK_UPPER_CASE: {

      charCheckObj.uppercaseCheck = action.value;

      return {
        ...state,
        characterCheck: charCheckObj
      }
    }

    case WS_PASSWORD_RULE_ACTIONS.CHECK_LOWER_CASE: {

      charCheckObj.lowercaseCheck = action.value;

      return {
        ...state,
        characterCheck: charCheckObj
      }
    }

    case WS_PASSWORD_RULE_ACTIONS.CHECK_NUMBER: {

      charCheckObj.numberCheck = action.value;

      return {
        ...state,
        characterCheck: charCheckObj
      }
    }

    case WS_PASSWORD_RULE_ACTIONS.CHECK_SPECIAL_CHARACTER: {

      charCheckObj.specialCharCheck = action.value;

      return {
        ...state,
        characterCheck: charCheckObj
      }
    }

    case WS_PASSWORD_RULE_ACTIONS.CHECK_ORG_ID: {

      return {
        ...state,
        orgIdCheck: action.value
      }
    }

    case WS_PASSWORD_RULE_ACTIONS.CHECK_DAILY_CHANGE_COUNT: {

      return {
        ...state,
        countLimitCheck: action.value
      }
    }

    case WS_PASSWORD_RULE_ACTIONS.CHECK_PASSWORD_HISTORY: {

      return {
        ...state,
        historyCheck: action.value
      }
    }

    case WS_PASSWORD_RULE_ACTIONS.PASS: {

      return {
        lengthCheck: true,
        characterCheck: {
          uppercaseCheck: true,
          lowercaseCheck: true,
          numberCheck: true,
          specialCharCheck: true
        },
        orgIdCheck: true,
        historyCheck: true,
        countLimitCheck: true
      }
    }
  }
}

export { WS_PASSWORD_RULE_ACTIONS, webServicePasswordRuleReducer };

